  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.gdpAlmondGuideReady === 'true') return;
      root.dataset.gdpAlmondGuideReady = 'true';

    // Localized UI copy only; result keys, scoring and tracking are unchanged.
    const quizCopy = {
  "fr": {
    "sweetQuestion": "Quel profil sucré vous attire le plus ?",
    "savoryQuestion": "Quel caractère vous attire le plus ?",
    "bothQuestion": "Quel parcours voulez-vous ouvrir ?",
    "discoveryQuestion": "Jusqu’où voulez-vous pousser la découverte ?",
    "countQuestion": "Combien de saveurs voulez-vous découvrir ?",
    "keepCustom": "Conserver la libre composition",
    "curatedTitle": "Un trio déjà composé",
    "customHelp": "Je poursuis vers les options proposées",
    "curatedHelp": "Trois saveurs distinctes, prêtes à comparer",
    "showSelection": "Voir ma sélection",
    "continue": "Continuer",
    "chooseAnswer": "Choisissez une réponse avant de continuer.",
    "showAll": "Voir les 8 saveurs",
    "collapse": "Réduire la sélection",
    "progress": "{step} sur 3",
    "question": "Question {step} sur 3",
    "statusQuestion": "Question {step} sur 3 : {legend}",
    "recommended": "Votre sélection recommandée : {title}",
    "match": "Votre parcours réunit {family}, {profile} et {format}.",
    "countOne": "{count} saveur affichée.",
    "countMany": "{count} saveurs affichées.",
    "customContinuation": "la poursuite vers une composition libre",
    "families": {
      "sweet": "une envie sucrée",
      "savory": "une envie salée et épicée",
      "both": "une envie de contrastes"
    },
    "profiles": {
      "warm": "une chaleur douce",
      "deep": "une rondeur chocolatée",
      "soft": "une douceur parfumée",
      "fruity": "un éclat fruité",
      "cheese": "une note fromagère",
      "spiced": "une chaleur épicée",
      "smoked": "un sillage fumé",
      "sharp": "une pointe vive",
      "sweet_trio": "un parcours tout en douceur",
      "discovery_trio": "un passage du doux au salé",
      "savory_trio": "un parcours salé et épicé",
      "custom": "une composition libre"
    },
    "formats": {
      "one": "le choix d’une seule saveur",
      "three": "la comparaison de trois saveurs",
      "curated": "un trio déjà composé",
      "all": "la découverte des huit saveurs",
      "custom": "une composition choisie librement"
    }
  },
  "en": {
    "sweetQuestion": "Which sweet profile appeals to you most?",
    "savoryQuestion": "Which character appeals to you most?",
    "bothQuestion": "Which tasting journey would you like to explore?",
    "discoveryQuestion": "How far would you like to take your discovery?",
    "countQuestion": "How many flavours would you like to discover?",
    "keepCustom": "Keep choosing freely",
    "curatedTitle": "A ready-made trio",
    "customHelp": "Continue to the available options",
    "curatedHelp": "Three distinct flavours, ready to compare",
    "showSelection": "See my selection",
    "continue": "Continue",
    "chooseAnswer": "Choose an answer before continuing.",
    "showAll": "View the 8 flavours",
    "collapse": "Narrow the selection",
    "progress": "{step} of 3",
    "question": "Question {step} of 3",
    "statusQuestion": "Question {step} of 3: {legend}",
    "recommended": "Your recommended selection: {title}",
    "match": "Your journey brings together {family}, {profile} and {format}.",
    "countOne": "{count} flavour displayed.",
    "countMany": "{count} flavours displayed.",
    "customContinuation": "continuing to a freely chosen selection",
    "families": {
      "sweet": "a craving for sweetness",
      "savory": "a craving for savoury and spicy flavours",
      "both": "a taste for contrasts"
    },
    "profiles": {
      "warm": "gentle warmth",
      "deep": "chocolate richness",
      "soft": "fragrant sweetness",
      "fruity": "a fruity sparkle",
      "cheese": "a cheese note",
      "spiced": "spicy warmth",
      "smoked": "a smoky finish",
      "sharp": "a lively kick",
      "sweet_trio": "a journey through sweet flavours",
      "discovery_trio": "a journey from sweet to savoury",
      "savory_trio": "a savoury and spicy journey",
      "custom": "a freely chosen selection"
    },
    "formats": {
      "one": "a single flavour",
      "three": "a comparison of three flavours",
      "curated": "a ready-made trio",
      "all": "the discovery of all eight flavours",
      "custom": "a selection you put together freely"
    }
  },
  "de": {
    "sweetQuestion": "Welches süße Geschmacksprofil spricht Sie am meisten an?",
    "savoryQuestion": "Welcher Charakter spricht Sie am meisten an?",
    "bothQuestion": "Welche Genussreise möchten Sie beginnen?",
    "discoveryQuestion": "Wie weit möchten Sie Ihre Entdeckung führen?",
    "countQuestion": "Wie viele Sorten möchten Sie entdecken?",
    "keepCustom": "Die freie Zusammenstellung beibehalten",
    "curatedTitle": "Ein bereits zusammengestelltes Trio",
    "customHelp": "Weiter zu den verfügbaren Möglichkeiten",
    "curatedHelp": "Drei verschiedene Sorten zum Vergleichen",
    "showSelection": "Meine Auswahl ansehen",
    "continue": "Weiter",
    "chooseAnswer": "Wählen Sie eine Antwort, bevor Sie fortfahren.",
    "showAll": "Die 8 Sorten ansehen",
    "collapse": "Auswahl verkleinern",
    "progress": "{step} von 3",
    "question": "Frage {step} von 3",
    "statusQuestion": "Frage {step} von 3: {legend}",
    "recommended": "Ihre empfohlene Auswahl: {title}",
    "match": "Ihre Genussreise verbindet {family}, {profile} und {format}.",
    "countOne": "{count} Sorte angezeigt.",
    "countMany": "{count} Sorten angezeigt.",
    "customContinuation": "die Fortsetzung mit einer freien Zusammenstellung",
    "families": {
      "sweet": "die Lust auf Süßes",
      "savory": "die Lust auf Herzhaftes und Würziges",
      "both": "die Lust auf Kontraste"
    },
    "profiles": {
      "warm": "sanfte Wärme",
      "deep": "schokoladige Fülle",
      "soft": "duftende Süße",
      "fruity": "einen fruchtigen Akzent",
      "cheese": "eine Käsenote",
      "spiced": "würzige Wärme",
      "smoked": "einen rauchigen Nachklang",
      "sharp": "eine lebhafte Schärfe",
      "sweet_trio": "eine Reise durch süße Aromen",
      "discovery_trio": "einen Übergang von süß zu herzhaft",
      "savory_trio": "eine herzhafte und würzige Reise",
      "custom": "eine freie Zusammenstellung"
    },
    "formats": {
      "one": "die Wahl einer einzigen Sorte",
      "three": "den Vergleich von drei Sorten",
      "curated": "ein bereits zusammengestelltes Trio",
      "all": "die Entdeckung aller acht Sorten",
      "custom": "eine frei gewählte Zusammenstellung"
    }
  },
  "es": {
    "sweetQuestion": "¿Qué perfil dulce le atrae más?",
    "savoryQuestion": "¿Qué carácter le atrae más?",
    "bothQuestion": "¿Qué recorrido quiere explorar?",
    "discoveryQuestion": "¿Hasta dónde quiere llevar el descubrimiento?",
    "countQuestion": "¿Cuántos sabores quiere descubrir?",
    "keepCustom": "Mantener la composición libre",
    "curatedTitle": "Un trío ya compuesto",
    "customHelp": "Continuar hacia las opciones disponibles",
    "curatedHelp": "Tres sabores distintos, listos para comparar",
    "showSelection": "Ver mi selección",
    "continue": "Continuar",
    "chooseAnswer": "Elija una respuesta antes de continuar.",
    "showAll": "Ver los 8 sabores",
    "collapse": "Reducir la selección",
    "progress": "{step} de 3",
    "question": "Pregunta {step} de 3",
    "statusQuestion": "Pregunta {step} de 3: {legend}",
    "recommended": "Su selección recomendada: {title}",
    "match": "Su recorrido reúne {family}, {profile} y {format}.",
    "countOne": "{count} sabor mostrado.",
    "countMany": "{count} sabores mostrados.",
    "customContinuation": "la continuación hacia una composición libre",
    "families": {
      "sweet": "un deseo de dulzura",
      "savory": "un deseo de sabores salados y especiados",
      "both": "un deseo de contrastes"
    },
    "profiles": {
      "warm": "una calidez suave",
      "deep": "una redondez de chocolate",
      "soft": "una dulzura aromática",
      "fruity": "un toque afrutado",
      "cheese": "una nota de queso",
      "spiced": "una calidez especiada",
      "smoked": "un rastro ahumado",
      "sharp": "un toque intenso",
      "sweet_trio": "un recorrido dulce",
      "discovery_trio": "un paso de lo dulce a lo salado",
      "savory_trio": "un recorrido salado y especiado",
      "custom": "una composición libre"
    },
    "formats": {
      "one": "la elección de un solo sabor",
      "three": "la comparación de tres sabores",
      "curated": "un trío ya compuesto",
      "all": "el descubrimiento de los ocho sabores",
      "custom": "una composición elegida libremente"
    }
  },
  "nl": {
    "sweetQuestion": "Welk zoet smaakprofiel spreekt u het meest aan?",
    "savoryQuestion": "Welk karakter spreekt u het meest aan?",
    "bothQuestion": "Welke smaakreis wilt u verkennen?",
    "discoveryQuestion": "Hoe ver wilt u gaan in uw ontdekking?",
    "countQuestion": "Hoeveel smaken wilt u ontdekken?",
    "keepCustom": "Vrij blijven samenstellen",
    "curatedTitle": "Een samengesteld trio",
    "customHelp": "Verder naar de beschikbare opties",
    "curatedHelp": "Drie verschillende smaken om te vergelijken",
    "showSelection": "Mijn selectie bekijken",
    "continue": "Doorgaan",
    "chooseAnswer": "Kies een antwoord voordat u doorgaat.",
    "showAll": "Bekijk de 8 smaken",
    "collapse": "De selectie beperken",
    "progress": "{step} van 3",
    "question": "Vraag {step} van 3",
    "statusQuestion": "Vraag {step} van 3: {legend}",
    "recommended": "Uw aanbevolen selectie: {title}",
    "match": "Uw smaakreis combineert {family}, {profile} en {format}.",
    "countOne": "{count} smaak weergegeven.",
    "countMany": "{count} smaken weergegeven.",
    "customContinuation": "verdergaan met een vrije samenstelling",
    "families": {
      "sweet": "zin in zoet",
      "savory": "zin in hartige en kruidige smaken",
      "both": "zin in contrasten"
    },
    "profiles": {
      "warm": "zachte warmte",
      "deep": "ronde chocoladesmaak",
      "soft": "geurige zoetheid",
      "fruity": "een fruitig accent",
      "cheese": "een kaastoets",
      "spiced": "kruidige warmte",
      "smoked": "een rokerige afdronk",
      "sharp": "een pittig accent",
      "sweet_trio": "een reis langs zoete smaken",
      "discovery_trio": "een overgang van zoet naar hartig",
      "savory_trio": "een hartige en kruidige reis",
      "custom": "een vrije samenstelling"
    },
    "formats": {
      "one": "de keuze voor één smaak",
      "three": "het vergelijken van drie smaken",
      "curated": "een samengesteld trio",
      "all": "het ontdekken van alle acht smaken",
      "custom": "een vrij gekozen samenstelling"
    }
  },
  "pt": {
    "sweetQuestion": "Qual o perfil doce que mais lhe agrada?",
    "savoryQuestion": "Qual o carácter que mais lhe agrada?",
    "bothQuestion": "Que percurso pretende explorar?",
    "discoveryQuestion": "Até onde pretende levar a descoberta?",
    "countQuestion": "Quantos sabores pretende descobrir?",
    "keepCustom": "Manter a composição livre",
    "curatedTitle": "Um trio já composto",
    "customHelp": "Continuar para as opções disponíveis",
    "curatedHelp": "Três sabores distintos, prontos a comparar",
    "showSelection": "Ver a minha seleção",
    "continue": "Continuar",
    "chooseAnswer": "Escolha uma resposta antes de continuar.",
    "showAll": "Ver os 8 sabores",
    "collapse": "Reduzir a seleção",
    "progress": "{step} de 3",
    "question": "Pergunta {step} de 3",
    "statusQuestion": "Pergunta {step} de 3: {legend}",
    "recommended": "A sua seleção recomendada: {title}",
    "match": "O seu percurso reúne {family}, {profile} e {format}.",
    "countOne": "{count} sabor apresentado.",
    "countMany": "{count} sabores apresentados.",
    "customContinuation": "a continuação para uma composição livre",
    "families": {
      "sweet": "uma vontade de sabores doces",
      "savory": "uma vontade de sabores salgados e condimentados",
      "both": "uma vontade de contrastes"
    },
    "profiles": {
      "warm": "um calor suave",
      "deep": "uma redondeza de chocolate",
      "soft": "uma doçura aromática",
      "fruity": "um toque frutado",
      "cheese": "uma nota de queijo",
      "spiced": "um calor condimentado",
      "smoked": "um rasto fumado",
      "sharp": "um toque vivo",
      "sweet_trio": "um percurso doce",
      "discovery_trio": "uma passagem do doce ao salgado",
      "savory_trio": "um percurso salgado e condimentado",
      "custom": "uma composição livre"
    },
    "formats": {
      "one": "a escolha de um só sabor",
      "three": "a comparação de três sabores",
      "curated": "um trio já composto",
      "all": "a descoberta dos oito sabores",
      "custom": "uma composição escolhida livremente"
    }
  }
};
    quizCopy.it = {"sweetQuestion": "Quale profilo dolce ti attira di più?", "savoryQuestion": "Quale carattere ti attira di più?", "bothQuestion": "Quale percorso vuoi aprire?", "discoveryQuestion": "Fin dove vuoi spingere la scoperta?", "countQuestion": "Quanti gusti vuoi scoprire?", "keepCustom": "Mantieni la composizione libera", "curatedTitle": "Un trio già composto", "customHelp": "Proseguo verso le opzioni proposte", "curatedHelp": "Tre gusti distinti, pronti da confrontare", "showSelection": "Vedi la mia selezione", "continue": "Continua", "chooseAnswer": "Scegli una risposta prima di continuare.", "showAll": "Vedi gli 8 gusti", "collapse": "Riduci la selezione", "progress": "{step} di 3", "question": "Domanda {step} di 3", "statusQuestion": "Domanda {step} di 3: {legend}", "recommended": "La tua selezione consigliata: {title}", "match": "Il tuo percorso unisce {family}, {profile} e {format}.", "countOne": "{count} gusto visualizzato.", "countMany": "{count} gusti visualizzati.", "customContinuation": "il proseguimento verso una composizione libera", "families": {"sweet": "una voglia di dolce", "savory": "una voglia di salato e speziato", "both": "una voglia di contrasti"}, "profiles": {"warm": "un calore dolce", "deep": "una rotondità al cioccolato", "soft": "una dolcezza profumata", "fruity": "una vivacità fruttata", "cheese": "una nota di formaggio", "spiced": "un calore speziato", "smoked": "una scia affumicata", "sharp": "una punta vivace", "sweet_trio": "un percorso tutto dolcezza", "discovery_trio": "un passaggio dal dolce al salato", "savory_trio": "un percorso salato e speziato", "custom": "una composizione libera"}, "formats": {"one": "la scelta di un solo gusto", "three": "il confronto di tre gusti", "curated": "un trio già composto", "all": "la scoperta degli otto gusti", "custom": "una composizione scelta liberamente"}};
    const locale = String(window.Shopify?.locale || document.documentElement.lang || 'fr').toLowerCase().split(/[-_]/)[0];
    const copy = quizCopy[locale] || quizCopy.fr;
    const text = (key, values = {}) => copy[key].replace(/\{(\w+)\}/g, (_, name) => String(values[name] ?? ''));

    const track = (event, parameters = {}) => {
      if (window.Shopify && window.Shopify.designMode) return;
      const queue = window.dataLayer = window.dataLayer || [];
      if (typeof queue.push === 'function') queue.push({ event, ...parameters });
    };

    const form = root.querySelector('[data-quiz-form]');
    const results = root.querySelector('[data-results]');
    const steps = [...root.querySelectorAll('[data-step]')];
    const progress = root.querySelector('[data-progress]');
    const stepLabel = root.querySelector('[data-step-label]');
    const next = root.querySelector('[data-next]');
    const nextCopy = root.querySelector('[data-next-copy]');
    const back = root.querySelector('[data-back]');
    const status = root.querySelector('[data-status]');
    let step = 1;
    let started = false;
    let completed = false;
    let previousFamily = '';

    const activeFieldset = () => root.querySelector(`[data-step="${step}"]`);
    const checked = (fieldset = activeFieldset()) => fieldset?.querySelector('input[type="radio"]:checked');
    const answer = (question) => root.querySelector(`[data-question="${question}"] input[type="radio"]:checked`)?.value || '';
    const family = () => answer('family');

    const setBranch = (fieldset, key) => {
      fieldset.querySelectorAll('[data-branch]').forEach((branch) => {
        const active = branch.dataset.branch === key;
        branch.hidden = !active;
        branch.querySelectorAll('input').forEach((input) => { input.disabled = !active; });
      });
    };

    const prepareAdaptiveStep = () => {
      if (step === 2) {
        const fieldset = activeFieldset();
        setBranch(fieldset, family());
        fieldset.querySelector('[data-adaptive-legend]').textContent = family() === 'sweet'
          ? copy.sweetQuestion
          : family() === 'savory'
            ? copy.savoryQuestion
            : copy.bothQuestion;
      }
      if (step === 3) {
        const fieldset = activeFieldset();
        setBranch(fieldset, family() === 'both' ? 'both' : 'standard');
        fieldset.querySelector('[data-adaptive-legend]').textContent = family() === 'both'
          ? copy.discoveryQuestion
          : copy.countQuestion;
        const curatedTitle = fieldset.querySelector('[data-curated-title]');
        const curatedHelp = fieldset.querySelector('[data-curated-help]');
        const customProfile = answer('profile') === 'custom';
        if (curatedTitle) curatedTitle.textContent = customProfile ? copy.keepCustom : copy.curatedTitle;
        if (curatedHelp) curatedHelp.textContent = customProfile ? copy.customHelp : copy.curatedHelp;
      }
    };

    const renderStep = (focus = false) => {
      steps.forEach((fieldset) => { fieldset.hidden = Number(fieldset.dataset.step) !== step; });
      prepareAdaptiveStep();
      if (progress) {
        progress.value = step;
        progress.textContent = text('progress', { step });
      }
      if (stepLabel) stepLabel.textContent = text('question', { step });
      if (nextCopy) nextCopy.textContent = step === 3 ? copy.showSelection : copy.continue;
      if (next) next.disabled = !checked();
      if (back) back.hidden = step === 1;
      const legend = activeFieldset()?.querySelector('legend');
      if (status && legend) status.textContent = text('statusQuestion', { step, legend: legend.textContent });
      if (focus && legend) legend.focus({ preventScroll: true });
    };

    const resultKey = () => {
      const selectedFamily = family();
      const profile = answer('profile');
      const format = answer('format');
      if (format === 'all') return 'integrale';
      if (format === 'custom') return 'custom';
      if (selectedFamily === 'both' && format === 'curated') {
        return { sweet_trio: 'trio_sucre', discovery_trio: 'trio_decouverte', savory_trio: 'trio_sale', custom: 'custom' }[profile] || 'trio_decouverte';
      }
      if (format === 'three') return selectedFamily === 'sweet' ? 'trio_sucre' : 'trio_sale';
      return {
        warm: 'cannelle', deep: 'chocolat', soft: 'coco', fruity: 'framboise',
        cheese: 'edam', spiced: 'piment', smoked: 'fumees', sharp: 'wasabi'
      }[profile] || 'trio_decouverte';
    };

    const matchSentence = () => {
      const familyLabel = copy.families[family()];
      const profileLabel = copy.profiles[answer('profile')];
      const formatLabel = answer('format') === 'curated' && answer('profile') === 'custom'
        ? copy.customContinuation
        : copy.formats[answer('format')];
      return text('match', { family: familyLabel, profile: profileLabel, format: formatLabel });
    };

    const showResult = () => {
      const key = resultKey();
      const selected = root.querySelector(`[data-result="${key}"]`);
      root.querySelectorAll('[data-result]').forEach((item) => { item.hidden = true; });
      if (!selected || completed) return;
      completed = true;
      selected.hidden = false;
      selected.querySelector('[data-match]').textContent = matchSentence();
      form.hidden = true;
      results.hidden = false;
      selected.querySelector('h3')?.focus({ preventScroll: true });
      if (status) status.textContent = text('recommended', { title: selected.querySelector('h3')?.textContent || '' });
      track('almond_quiz_complete', { result_handle: selected.dataset.resultHandle, family: family(), format: answer('format') });
    };

    if (form && results && steps.length === 3 && next && back) {
      form.hidden = false;
      form.addEventListener('submit', (event) => event.preventDefault());
      renderStep(false);
      form.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        if (step === 1) {
          if (!started) { track('almond_quiz_start', { entry_section: 'guide' }); started = true; }
          if (previousFamily && previousFamily !== family()) {
            root.querySelectorAll('[data-step="2"] input,[data-step="3"] input').forEach((input) => { input.checked = false; });
          }
          previousFamily = family();
        }
        if (step === 2) {
          root.querySelectorAll('[data-step="3"] input').forEach((input) => { input.checked = false; });
        }
        next.disabled = false;
      });
      next.addEventListener('click', () => {
        if (step === 3 && completed) return;
        const selected = checked();
        if (!selected) {
          if (status) status.textContent = copy.chooseAnswer;
          return;
        }
        track('almond_quiz_step', { step, answer_key: selected.value });
        if (step === 3) { showResult(); return; }
        step += 1;
        renderStep(true);
      });
      back.addEventListener('click', () => {
        if (step === 1) return;
        step -= 1;
        renderStep(true);
      });
      root.addEventListener('click', (event) => {
        if (!event.target.closest('[data-restart]')) return;
        const previousResult = root.querySelector('[data-result]:not([hidden])')?.dataset.resultHandle || '';
        track('almond_quiz_restart', { previous_result: previousResult });
        form.reset();
        root.querySelectorAll('[data-branch] input').forEach((input) => { input.disabled = false; });
        step = 1;
        started = false;
        completed = false;
        previousFamily = '';
        results.hidden = true;
        form.hidden = false;
        renderStep(false);
        activeFieldset()?.querySelector('legend')?.focus({ preventScroll: true });
        root.querySelector('.gdp-aq__quiz')?.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    }

    const filterButtons = [...root.querySelectorAll('[data-filter]')];
    const flavorCards = [...root.querySelectorAll('[data-flavor-card]')];
    const flavorGrid = root.querySelector('.gdp-aq__flavors');
    const filterStatus = root.querySelector('[data-filter-status]');
    let flavorExpanded = false;
    let flavorToggle = root.querySelector('[data-flavor-toggle]');

    flavorCards.forEach((card, index) => {
      if (index > 3) card.dataset.flavorExtra = '';
    });

    if (!flavorToggle && flavorGrid && flavorCards.length > 4) {
      if (!flavorGrid.id) flavorGrid.id = `${root.id || 'gdp-almond-guide'}-flavors`;
      flavorToggle = document.createElement('button');
      flavorToggle.type = 'button';
      flavorToggle.className = 'gdp-aq__flavor-toggle';
      flavorToggle.dataset.flavorToggle = '';
      flavorToggle.setAttribute('aria-expanded', 'false');
      flavorToggle.setAttribute('aria-controls', flavorGrid.id);
      flavorToggle.innerHTML = '<span data-flavor-toggle-label></span><span class="gdp-aq__flavor-toggle-mark" aria-hidden="true">+</span>';
      flavorGrid.insertAdjacentElement('afterend', flavorToggle);
    }

    const renderFlavors = (key = 'all') => {
      flavorCards.forEach((card, index) => {
        const matches = key === 'all' || card.dataset.categories.split(' ').includes(key);
        const beyondPreview = key === 'all' && index > 3 && !flavorExpanded;
        card.hidden = !matches || beyondPreview;
      });
      if (flavorToggle) {
        if (key === 'all') flavorToggle.removeAttribute('hidden');
        else flavorToggle.setAttribute('hidden', '');
        flavorToggle.setAttribute('aria-expanded', String(flavorExpanded));
        const label = flavorToggle.querySelector('[data-flavor-toggle-label]');
        if (label) label.textContent = flavorExpanded ? copy.collapse : copy.showAll;
      }
      const visibleCount = flavorCards.filter((card) => !card.hidden).length;
      if (filterStatus) filterStatus.textContent = text(visibleCount === 1 ? 'countOne' : 'countMany', { count: visibleCount });
    };

    const applyFilter = (key, shouldTrack = true) => {
      if (key !== 'all') flavorExpanded = false;
      filterButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === key)));
      renderFlavors(key);
      if (shouldTrack) track('almond_filter_use', { filter_key: key });
    };

    filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter)));
    flavorToggle?.addEventListener('click', () => {
      flavorExpanded = !flavorExpanded;
      renderFlavors('all');
      track('almond_flavor_expand', { expanded: flavorExpanded });
    });
    applyFilter('all', false);
    requestAnimationFrame(() => applyFilter('all', false));
    root.querySelectorAll('[data-path-filter]').forEach((button) => button.addEventListener('click', () => {
      applyFilter(button.dataset.pathFilter);
      root.querySelector('[data-gdp-aq-atlas]')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));

    root.addEventListener('click', (event) => {
      const pdp = event.target.closest('[data-pdp-link]');
      if (pdp) track('almond_guide_pdp_click', { product_handle: pdp.dataset.productHandle, source_section: pdp.dataset.source, result_or_browse: pdp.dataset.resultOrBrowse });
      const assortment = event.target.closest('[data-assortment-link]');
      if (assortment) track('almond_assortment_click', { product_handle: assortment.dataset.productHandle });
    });

    const trackGuideView = () => {
      if (window.__gdpAlmondGuideViewSent) return;
      window.__gdpAlmondGuideViewSent = true;
      track('almond_guide_view', { page_type: 'guide', device_group: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop' });
    };
    if ('IntersectionObserver' in window) {
      const viewObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        trackGuideView();
        observer.disconnect();
      }, { threshold: 0.1 });
      viewObserver.observe(root);
    } else {
      trackGuideView();
    }
    };

    const boot = (scope = document) => {
      const roots = [];
      if (scope.matches?.('[data-gdp-aq-root]')) roots.push(scope);
      scope.querySelectorAll?.('[data-gdp-aq-root]').forEach((candidate) => roots.push(candidate));
      roots.forEach(initialize);
    };

    const start = () => boot(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    if (!window.__gdpAlmondGuideSectionListener) {
      window.__gdpAlmondGuideSectionListener = true;
      document.addEventListener('shopify:section:load', (event) => boot(event.target));
    }
  })();
